/* @flow */

export {DynamicButtonContent} from './dynamic-button-content';
